import { gql } from '@apollo/client';
import { OrganizationNote } from '../types/organizationNote';
import { OrganizationNoteFieldsFragment } from '../fragments/organizationNote';

export interface GetOrganizationNotesResponse {
  organizationNotes: OrganizationNote[];
}

export const GET_ORGANIZATION_NOTES = gql`
  query GetOrganizationNotes($organizationId: String!) {
    organizationNotes(organizationId: $organizationId) {
      ...OrganizationNoteFields
    }
  }
  ${OrganizationNoteFieldsFragment}
`;
